import firebase from "./firebase";
import AppData from "./AppData";

export default {
  fetchItems(collection, field, from, to, selectFields) {
    return new Promise((resolve, reject) => {
      try {
        const db = firebase.firestore();
        const settings = {};
        db.settings(settings);
        var data = [];
        var ref = db.collection(collection);

        ref = ref.where(field, ">=", from);
        ref = ref.where(field, "<", to);
        if (selectFields) {
          selectFields.forEach(element => {
            ref = ref.select(element);
          });
        }
        ref
          .get()
          .then(result => {
            result.docs.forEach(element => {
              data.push(element.data());
            });
            resolve(data);
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        reject(err);
      }
    });
  },
  fetchWithFilter(collection, where, limit, last, orderBy, orderDesc = "desc") {
    return new Promise((resolve, reject) => {
      try {
        const db = firebase.firestore();
        const settings = {};
        db.settings(settings);
        var data = [];
        var ref = db.collection(collection);

        if (orderBy) {
          ref = ref.orderBy(orderBy, orderDesc);
        }
        if (where) {
          ref = ref.where(where.field, where.condition, where.value);
          if (last) {
            ref = ref.startAfter(last);
          }
          if (limit) {
            ref = ref.limit(limit);
          }
        }

        ref
          .get()
          .then(result => {
            // console.log(result);
            result.docs.forEach(element => {
              data.push(element.data());
            });
            resolve({ data: data, last: result.docs[result.docs.length - 1] });
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        reject(err);
      }
    });
  },
  fetchDoc(collection, doc) {
    return new Promise(resolve => {
      const db = firebase.firestore();
      const settings = {};
      db.settings(settings);
      var data = {};
      db.collection(collection)
        .doc(doc)
        .get()
        .then(result => {
          resolve(result.data());
        })
        .catch(() => {
          data = this[collection][doc];
          resolve(data);
        });
    });
  },
  fetchDocsCount(collection) {
    return new Promise(resolve => {
      const db = firebase.firestore();
      const settings = {};
      db.settings(settings);
      db.collection(collection)
        .get()
        .then(snap => {
          resolve(snap.size); // will return the collection size
        });
    });
  },
  fetchData(collection, limit) {
    return new Promise(resolve => {
      if (this.cached.hasOwnProperty(collection)) {
        resolve(this.cached[collection]);
      }
      const db = firebase.firestore();
      const settings = {};
      db.settings(settings);
      var data = {};
      if (limit) {
        db.collection(collection)
          .orderBy("id", "desc")
          .limit(limit)
          .get()
          .then(result => {
            result.docs.forEach(element => {
              data[element.id] = element.data();
            });
            this.cached[collection] = data;
            resolve(data);
          })
          .catch(() => {
            data = this[collection];
            this.cached[collection] = data;
            resolve(data);
          });
      } else {
        db.collection(collection)
          .get()
          .then(result => {
            result.docs.forEach(element => {
              data[element.id] = element.data();
            });
            this.cached[collection] = data;
            resolve(data);
          })
          .catch(() => {
            data = this[collection];
            this.cached[collection] = data;
            resolve(data);
          });
      }
    });
  },
  uploadAppData() {
    const db = firebase.firestore();
    const settings = {};
    db.settings(settings);
    let collections = [
      "navigation",
      "home",
      "main",
      "about",
      "newslist",
      "news",
      "products",
      "product",
      "contacts",
      "partners",
      "productslist",
    ];
    collections.forEach(element => {
      var data = AppData[element];
      console.log(data);
      for (let key in data) {
        if (Array.isArray(data[key])) {
          db.collection(element)
            .doc(key)
            .set({ list: data[key] })
            .then(() => {})
            .catch(() => {});
        } else {
          db.collection(element)
            .doc(key)
            .set(data[key])
            .then(() => {})
            .catch(() => {});
        }
      }
    });
  },
  sendMail(name, email, phone, message) {
    return new Promise((resolve, reject) => {
      const db = firebase.firestore();
      const settings = {};
      db.settings(settings);
      db.collection("mail")
        .add({
          name: name,
          email: email,
          phone: phone,
          message: message,
          date: new Date().getTime(),
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  callRequest(name, phone) {
    return new Promise((resolve, reject) => {
      const db = firebase.firestore();
      const settings = {};
      db.settings(settings);
      db.collection("calls")
        .add({
          name: name,
          phone: phone,
          date: new Date().getTime(),
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  cached: {},
};
